import React, { useState } from 'react';
import { Crown, Check, Loader2, Sparkles, Ticket } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent } from './ui/dialog';
import { useApp } from '../context/AppContext';
import { PARENT_PLAN } from '../mock';
import api from '../api';

export default function UpgradeProModal({ open, onClose }) {
  const { user } = useApp();
  const [busy, setBusy] = useState(false);

  const checkout = async (lookup_key) => {
    setBusy(true);
    try {
      const r = await api.post('/payments/checkout', {
        lookup_key,
        origin_url: window.location.origin,
        user_id: user?.id,
      });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      toast.error('Could not start checkout. Please try again.');
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent
        data-testid="upgrade-pro-modal"
        className="max-w-[92vw] overflow-hidden rounded-3xl border-none p-0 sm:max-w-md"
      >
        <div className="bg-[hsl(var(--coral))] px-6 pb-7 pt-8 text-center text-white">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white/20 backdrop-blur">
            <Crown className="h-7 w-7" />
          </div>
          <h2 className="mt-4 text-2xl font-extrabold leading-tight">You've used all 3 free questions</h2>
          <p className="mt-1.5 text-sm text-white/90">Upgrade to keep asking — unlimited AI vet help for you and your cat, day or night.</p>
        </div>

        <div className="px-6 pb-6 pt-5">
          <ul className="space-y-2.5">
            {PARENT_PLAN.perks.map((p) => (
              <li key={p} className="flex items-center gap-2.5 text-sm font-medium text-foreground">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent">
                  <Check className="h-3.5 w-3.5 text-[hsl(var(--coral))]" />
                </span>
                {p}
              </li>
            ))}
          </ul>

          <button
            data-testid="upgrade-pro-checkout-btn"
            onClick={() => checkout('purrpal_parent_pro')}
            disabled={busy}
            className="coral-btn mt-6 flex w-full items-center justify-center gap-2 rounded-2xl py-3.5 text-base font-bold text-white disabled:opacity-70"
          >
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Crown className="h-5 w-5" />}
            Upgrade to PRO – ${PARENT_PLAN.price}/mo
          </button>

          <button
            data-testid="upgrade-pro-bundle-btn"
            onClick={() => checkout('purrpal_parent_bundle')}
            disabled={busy}
            className="mt-2 flex w-full items-center justify-center gap-2 rounded-2xl border border-border bg-white py-3 text-sm font-bold text-foreground disabled:opacity-70"
          >
            <Sparkles className="h-4 w-4 text-[hsl(var(--coral))]" />
            Get both apps (Purrflect + Wooflect) – ${PARENT_PLAN.bundlePrice}/mo
          </button>

          <button
            data-testid="upgrade-pro-later-btn"
            onClick={() => onClose?.()}
            className="mt-3 w-full text-center text-sm font-semibold text-muted-foreground hover:text-foreground"
          >
            Maybe later
          </button>

          <div className="mt-4 flex items-center justify-center gap-1.5 border-t border-border pt-4 text-sm font-semibold text-muted-foreground" data-testid="promo-hint">
            <Ticket className="h-4 w-4 text-[hsl(var(--coral))]" />
            Have a beta or promo code? Enter it at checkout.
          </div>

          <p className="mt-3 text-center text-xs text-muted-foreground">Cancel anytime · Your free questions reset next month</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
